import React from 'react'
import '../../assets/css/CustomStyle.css';
import GrayBtn from '../Button/GrayBtn';


export default function Category(props) {
  const {ImageClassName , ContentClassName ,ClasName} = props
  return (
    <div className={`${ClasName} section-padding 1440:py-[5rem] 999:py-[3.8rem] 768:py-[2.9rem] py-[25px] bg-[#FDFBF7] grid 999:grid-cols-2 grid-cols-1 items-center justify-center 1550:gap-[3.125rem] 1350:gap-[2.875rem] gap-[2rem]`}>
      <div className={`${ImageClassName}  1550:border-[2.5rem]  1350:border-[30px] 768:border-[25px] border-[20px] border-[#FACBAE] rounded-[20px] `}>
         <div className='999:w-full 600:h-[26.25rem] h-[60vw] bg-white rounded-[20px] overflow-hidden'>

         </div>
      </div>
      <div className={`${ContentClassName}`}>
        <p className='text-orange font-[450] text-[16px]  '>Category</p>
        <p className='text-[2.5rem] font-[450] primary-text py-[9px]'>Lorem ipsum dolor sit amet</p>
        <p className='secondary-text text-[1.25rem] font-[450]'>Lorem ipsum dolor sit amet consectetur. Porttitor mi euismod odio adipiscing massa morbi. Amet nisl in habitasse ipsum. Imperdiet enim fringilla massa suspendisse faucibus id pretium amet penatibus.</p>
        <div className='1550:mt-[1.875rem] 1350:mt-[1.4rem] 999:mt-[1.2rem] section-primary-bg p-[25px] 1550:mb-[2.875rem] 1350:mb-[2.5rem] 999:mb-[2.2rem] mb-[20px] rounded-[10px]'>
          <p className=' pb-[9px] text-[1.375rem] font-medium'>Lorem ipsum dolor sit amet consectetur.</p>
          <p className=' text-[1.25rem] font-medium'>Lorem ipsum dolor sit amet consectetur. Porttitor mi euismod odio adipiscing massa morbi. Amet nisl in habitasse ipsum. Imperdiet enim fringilla massa suspendisse faucibus id pretium amet penatibus.</p>
        </div>
          <GrayBtn className='!1350:py-[10px] py-[8px] !1350px-[14px] 768:px-[12px] px-[11px] 1350:text-[18px] !768:text-[14px] text-[12px] gap-[8px]' value='Take a Look' />
      </div>
    </div>
  )
}
